import React, { useState, useContext } from 'react';
import { InputContext } from '../contexts/InputContext';

const Ayuda = () => {
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [videoElegido, setVideoElegido] = useState({
    titulo: '',
    enlace: ''
  })

  const linkNoLogueado = [
    { titulo: 'Cómo registrarse?',
      enlace: 'https://www.youtube.com/embed/NhUe-spmrzw?si=aqhd-Px-jI7N0rzW' }, // YT TC
    { titulo: 'Cómo Postularme?',
      enlace: 'https://www.youtube.com/embed/mLixLkx7rPI?si=bEkj03mt4DfAOoim' }, // YT TC
    ]

  const linksAdmin = [
    { titulo: 'Cómo crear nuevos usuarios, modificar o eliminar existentes ?',
    enlace: 'https://www.youtube.com/embed/fWd8_KuY7cM?si=VLDjgTF_u0or04R9' }, // YT TC
    { titulo: 'Cómo crear concursos, modificar o eliminar existentes ?',
    enlace: 'https://www.youtube.com/embed/YdR7YGOpc7M?si=ifIVXAOPL8sLRQUS' }, // YT TC
    { titulo: 'Cómo crear cargos y categorias?',
    enlace: 'https://www.youtube.com/embed/EP9gGKNVyfE?si=S5EffeP2OLIhMmJt' }, // YT TC
    { titulo: 'Cómo ver las postulaciones y gestionarlas ?',
    enlace: 'https://www.youtube.com/embed/HC0PazExG9Q?si=kyWO5tkXEcYeXnnK' }, // YT TC
    { titulo: 'Cómo modificar mis datos personales?',
    enlace: 'https://www.youtube.com/embed/0Eu5c-paTjg?si=uRHYoOklg_ofKsfg' },
    { titulo: 'Cómo cambiar mi clave?',
    enlace: 'https://www.youtube.com/embed/65wpnkuwnWs?si=rYzTxPbWj7R2L0kg' },
  ]

  const linksPostulante = [
    { titulo: 'Cómo modificar mis datos personales?',
    enlace: 'https://www.youtube.com/embed/7-NjCNIGQFQ?si=2lV_ZI9H3mnh7WJS' },
    { titulo: 'Cómo cambiar mi clave?',
    enlace: 'https://www.youtube.com/embed/65wpnkuwnWs?si=rYzTxPbWj7R2L0kg' },
    { titulo: 'Cómo registrarse?',
    enlace: 'https://www.youtube.com/embed/NhUe-spmrzw?si=aqhd-Px-jI7N0rzW' }, // YT TC
    { titulo: 'Cómo Postularme?',
      enlace: 'https://www.youtube.com/embed/mLixLkx7rPI?si=bEkj03mt4DfAOoim' }, // YT TC
  ]

  const linksJurado = [
    { titulo: 'Cómo colocar puntaje a registrados admitidos ?',
      enlace: 'https://www.youtube.com/embed/tBhrU4ogc-8?si=scQ_FfIAHrbv__mi' }, // YT TC
    { titulo: 'Cómo modificar mis datos personales?',
    enlace: 'https://www.youtube.com/embed/7-NjCNIGQFQ?si=2lV_ZI9H3mnh7WJS' },
    { titulo: 'Cómo cambiar mi clave?',
    enlace: 'https://www.youtube.com/embed/65wpnkuwnWs?si=rYzTxPbWj7R2L0kg' },
    { titulo: 'Cómo ver los candidatos revisados ?',
    enlace: 'https://www.youtube.com/embed/I41eNK1Tr6s?si=7fGEf4RyMQl7xfpV' },
  ]

  const linksVeedor = [
    { titulo: 'El Veedor solo puede ver',
      enlace: 'https://www.youtube.com/embed/HqmSrq-WlmI?si=IMcHBmxyTKCoSTyO' }, // YT TC
    { titulo: 'Cómo modificar mis datos personales?',
    enlace: 'https://www.youtube.com/embed/7-NjCNIGQFQ?si=2lV_ZI9H3mnh7WJS' },
    { titulo: 'Cómo cambiar mi clave?',
    enlace: 'https://www.youtube.com/embed/65wpnkuwnWs?si=rYzTxPbWj7R2L0kg' },
    { titulo: 'Cómo ver los candidatos revisados ?',
    enlace: 'https://www.youtube.com/embed/I41eNK1Tr6s?si=7fGEf4RyMQl7xfpV' },
  ]


  const CardAyuda = ({titulo, enlace}) => {
    return (
      <div className='card text-center'>
        <div className='card-body'>
          <h5 className='card-title'>{titulo}</h5>

          {/* <but className='btn btn-primary' href={} target='_blank'>Ver</a> */}
          <button type="button" className="btn btn-outline-dark" onClick={() => setVideoElegido({titulo, enlace})} data-bs-toggle="modal" data-bs-target="#videoYoutube" >Ver video</button>
          {/* <div className='embed-responsive embed-responsive-16by9'>
            <iframe className='embed-responsive-item' width='560' height='315' src='https://www.youtube.com/embed/lJ5uWWLRTCU?si=Bhb8CriKalDJVF0n' title='YouTube video player' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' allowborder='0' allowFullScreen></iframe>
          </div> */}
        </div>
      </div>
    )
  }


  return (
    <div>
      <h1>Ayuda</h1>
      <div className='row'>
      {authInformation.autenticado === false &&  (
        linkNoLogueado.map((p, i) => (
          <div key={i} className='col-md-6 mb-3'>
            <CardAyuda titulo={p.titulo} enlace={p.enlace} />
          </div>
          ))
      )}

      {(authInformation.autenticado === true) && (authInformation.rol === 'Admin') &&  (
        linksAdmin.map((p, i) => (
          <div key={i} className='col-md-6 mb-3'>
            <CardAyuda titulo={p.titulo} enlace={p.enlace} />
          </div>
          ))
      )}
      {(authInformation.autenticado === true) && (authInformation.rol === 'Registrado') &&  (
        linksPostulante.map((p, i) => (
          <div key={i} className='col-md-6 mb-3'>
            <CardAyuda titulo={p.titulo} enlace={p.enlace} />
          </div>
          ))
      )}
      {(authInformation.autenticado === true) && (authInformation.rol === 'Jurado') &&  (
        linksJurado.map((p, i) => (
          <div key={i} className='col-md-6 mb-3'>
            <CardAyuda titulo={p.titulo} enlace={p.enlace} />
          </div>
          ))
      )}
      {(authInformation.autenticado === true) && (authInformation.rol === 'Veedor') &&  (
        linksVeedor.map((p, i) => (
          <div key={i} className='col-md-6 mb-3'>
            <CardAyuda titulo={p.titulo} enlace={p.enlace} />
          </div>
          ))
      )}
      </div>

      <div className="modal fade" data-bs-backdrop="static" id="videoYoutube" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">{videoElegido.titulo}</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className='container-fluid text-center'>
                <iframe className='embed-responsive-item' width='768' height='433' src={videoElegido.enlace} title={videoElegido.titulo} allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' allowborder='0' allowFullScreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ayuda;